import { Text, View } from '@react-pdf/renderer';
import ListItem from './listItem';
import InputUtils from 'helpers/inputUtils';

function FinanceDetails({ financeDetailsData, coveragesData }) {
  const inputUtils = new InputUtils();

  return (
    <View
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        marginTop: 20,
        width: '100%',
      }}
    >
      <Text style={{ fontWeight: 600, fontSize: 18 }}>
        Commercial Truck Insurance
      </Text>
      <Text style={{ fontWeight: 600, fontSize: 14, marginTop: 10 }}>
        Premium Finance Details
      </Text>
      <View
        style={{
          maxWidth: 1000,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          marginTop: 10,
        }}
      >
        <View
          style={{
            width: '80%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            border: '1.5px solid black',
          }}
        >
          <ListItem
            item="Down Payment"
            value={
              financeDetailsData.downPayment
                ? inputUtils.currency(financeDetailsData.downPayment)
                : '$0'
            }
            whiteBg
            unlimited
          />
          <ListItem
            item="Number of Payments"
            value={
              financeDetailsData.numberOfPayments
                ? financeDetailsData.numberOfPayments
                : '0'
            }
            unlimited
          />
          <ListItem
            item="Payment Amount"
            value={
              financeDetailsData.paymentAmount
                ? inputUtils.currency(
                    financeDetailsData.paymentAmount
                  )
                : '$0'
            }
            whiteBg
            unlimited
          />
          <ListItem
            item="Effective APR"
            value={
              financeDetailsData.effectiveAPR
                ? financeDetailsData.effectiveAPR + '%'
                : '0%'
            }
            unlimited
          />
        </View>
      </View>
      <Text style={{ fontWeight: 600, fontSize: 18, marginTop: 10 }}>
        Price Indication Summary
      </Text>
      <View
        style={{
          maxWidth: 1000,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        <View
          style={{
            width: '80%',
            backgroundColor: '#000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'row',
          }}
        >
          <View
            style={{
              width: 'auto',
              justifyContent: 'center',
              alignItems: 'flex-start',
              margin: 10,
            }}
          >
            <Text
              style={{
                fontWeight: 600,
                fontSize: 15,
                color: 'white',
              }}
            >
              Coverages
            </Text>
          </View>

          <View
            style={{
              width: 'auto',
              justifyContent: 'center',
              alignItems: 'flex-start',
              margin: 10,
            }}
          >
            <Text
              style={{
                fontWeight: 600,
                fontSize: 15,
                color: 'white',
              }}
            >
              Total Cost
            </Text>
          </View>
        </View>
        <View
          style={{
            width: '80%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            border: '1.5px solid black',
          }}
        >
          <ListItem
            item="Automobile Liability"
            value={
              coveragesData.automobileLiability
                ? inputUtils.currency(
                    coveragesData.automobileLiability
                  )
                : 0
            }
            whiteBg
            unlimited
          />
          <ListItem
            item="Automobile Physical Damage"
            value={
              coveragesData.automobilePhysicalDamage
                ? inputUtils.currency(
                    coveragesData.automobilePhysicalDamage
                  )
                : 0
            }
            unlimited
          />
          <ListItem
            item="Motor Truck Cargo"
            value={
              coveragesData.motorTruckCargo
                ? inputUtils.currency(coveragesData.motorTruckCargo)
                : 0
            }
            whiteBg
            unlimited
          />
          <ListItem
            item="Truckers General Liability"
            value={
              coveragesData.truckersGeneralLiability
                ? inputUtils.currency(
                    coveragesData.truckersGeneralLiability
                  )
                : 0
            }
            unlimited
          />
          <ListItem
            item="Non-Trucking Liability"
            value={
              coveragesData.nonTruckingLiability
                ? inputUtils.currency(
                    coveragesData.nonTruckingLiability
                  )
                : 0
            }
            whiteBg
            unlimited
          />
          <ListItem
            item="Total Cost"
            value={
              coveragesData.totalCost
                ? inputUtils.currency(coveragesData.totalCost)
                : 0
            }
            unlimited
            last
          />
        </View>
      </View>
    </View>
  );
}
export default FinanceDetails;
